module.exports = __webpack_public_path__ + "static/media/exeter.5ca60698.png";